import {Box} from "@mui/material";
import QRCodeSVG from "react-qr-code";
import {QR_LOGO_MAX_RATIO, QR_LOGO_PAD_RATIO, QR_LOGO_RADIUS_RATIO, qrLogoLength} from "./signingQrBranding.util";

interface Props {
    /** The guest link; never rendered as text. */
    value: string
    /** A pixel size, or a CSS length (e.g. 'min(70vw, 70vh)') that scales with the viewport via the viewBox. */
    size?: number | string
    padding?: number
    /** Organization mark over the center; resolved by `useSigningQrLogoUrl`. */
    logoUrl?: string
}

/** Only used when the caller sizes the code with CSS - the viewBox makes the number irrelevant. */
const RESPONSIVE_RENDER_SIZE = 1024

/**
 * Copied from `surveys/share/SurveyQrCode.tsx`: the code, always on white so a camera reads it in
 * dark mode too. The logo sits over the center on a white pad, which is only safe with error
 * correction H; without a logo, M keeps the code less dense and quicker to scan from a screen.
 */
const SigningQrCode = ({value, size = 200, padding = 2, logoUrl}: Props) => {

    const renderSize = typeof size === 'number' ? size : RESPONSIVE_RENDER_SIZE
    const responsiveStyle = typeof size === 'string'
        ? {width: size, height: size, maxWidth: '100%'}
        : undefined

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                flexShrink: 0,
                p: padding,
                backgroundColor: 'common.white',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
            }}
        >
            <QRCodeSVG value={value} size={renderSize} level={logoUrl ? 'H' : 'M'} style={responsiveStyle}/>

            {!!logoUrl && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        display: 'flex',
                        p: qrLogoLength(size, QR_LOGO_MAX_RATIO * QR_LOGO_PAD_RATIO),
                        backgroundColor: 'common.white',
                        borderRadius: qrLogoLength(size, QR_LOGO_MAX_RATIO * QR_LOGO_RADIUS_RATIO),
                    }}
                >
                    <Box
                        component={'img'}
                        src={logoUrl}
                        alt={''}
                        sx={{
                            display: 'block',
                            maxWidth: qrLogoLength(size, QR_LOGO_MAX_RATIO),
                            maxHeight: qrLogoLength(size, QR_LOGO_MAX_RATIO),
                            objectFit: 'contain',
                        }}
                    />
                </Box>
            )}
        </Box>
    )
}

export default SigningQrCode
